// An empty month stays blank so the map reads as its statements. The plus shows under the pointer.
export const AddMark = () => (
  <span className="opacity-0 transition-opacity group-hover/cell:opacity-100">
    +
  </span>
)
